import React from "react";
import {
  ROUTE_ASSISTANCES,
  ROUTE_CLIENTS,
  ROUTE_DASHBOARD,
  ROUTE_SEARCH,
  ROUTE_STAMPING,
  ROUTE_TEAMS,
  ROUTE_USERS
} from "@/utils/context/constants";
import Iconify from "@/components/iconify";

// ----------------------------------------------------------------------

/*const icon = name => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);*/

const navConfig = [
  {
    type: 'link',
    title: "dashboard",
    path: ROUTE_DASHBOARD,
    icon: <Iconify icon="line-md:speed-loop" />
  },
  {
    type: 'link',
    title: "squadre",
    path: ROUTE_TEAMS,
    icon: <Iconify icon="mingcute:department-line" />
  },
  {
    type: 'link',
    title: "utenti",
    path: ROUTE_USERS,
    icon: <Iconify icon="mingcute:user-add-2-line" />
  },
  {
    type: 'link',
    title: "clienti",
    path: ROUTE_CLIENTS,
    icon: <Iconify icon="mingcute:phone-call-line" />
  },
  {
    type: 'divider',
    text: 'ASSISTENZE',
    textAlign: 'left',
    orientation: 'horizontal',
    variant: 'middle'
  },
  {
    type: 'link',
    title: "crea",
    path: ROUTE_STAMPING,
    icon: <Iconify icon="mingcute:badge-line" />
  },
  {
    type: 'link',
    title: "vedi",
    path: ROUTE_ASSISTANCES,
    icon: <Iconify icon="mingcute:bill-line" />
  },
  {
    type: 'divider',
    text: 'RICERCA',
    textAlign: 'left',
    orientation: 'horizontal',
    variant: 'middle'
  },
  {
    type: 'link',
    title: "esegui",
    path: ROUTE_SEARCH,
    icon: <Iconify icon="line-md:person-search" />
  },
  /*{
    title: "login",
    path: ROUTE_LOGIN,
    icon: icon("ic_lock")
  },
  {
    title: "Not found",
    path: ROUTE_NOT_FOUND,
    icon: icon("ic_disabled")
  }*/
];

export default navConfig;
